export default function _findGetResult(v, x) {
    return x;
}
